import { render, staticRenderFns } from "./EmailMarketingList.vue?vue&type=template&id=38acefd4&scoped=true"
import script from "./EmailMarketingList.vue?vue&type=script&lang=js"
export * from "./EmailMarketingList.vue?vue&type=script&lang=js"
import style0 from "./EmailMarketingList.vue?vue&type=style&index=0&id=38acefd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acefd4",
  null
  
)

export default component.exports